import * as $runtime from "../runtime.js";
import * as Data$dArray$dNonEmpty$dInternal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dMap$dExtra from "../Data.Map.Extra/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Restaumatic$dCoreSites$dTranslations$dKeys from "../Restaumatic.CoreSites.Translations.Keys/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
const validateAvailability = catalogue => v => productKey => {
  const $0 = v.locale;
  const parameterChoiceUnavailable = (parameter, choice) => Data$dEither.$Either(
    "Left",
    Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.menu.availabilityValidation.parameterChoiceUnavailable),
      {
        parameterName: Restaumatic$dI18n$dTypes.getLocalization($0)(Data$dRecord.unsafeGet("name")(parameter)),
        choiceName: Restaumatic$dI18n$dTypes.getLocalization($0)(Data$dRecord.unsafeGet("name")(choice))
      }
    )
  );
  const modifierItemUnavailable = (_modifier, item) => Data$dEither.$Either(
    "Left",
    Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.menu.availabilityValidation.modifierItemUnavailable),
      {itemName: Restaumatic$dI18n$dTypes.getLocalization($0)(Data$dRecord.unsafeGet("name")(item))}
    )
  );
  const processPartLike = (parentParameterValues, part) => {
    const parameterValues = Data$dMap$dInternal.unionWith(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Data$dFunction.const)(parentParameterValues)(Data$dMap$dExtra.mapKeys(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterId.CustomParameter)(Data$dMap$dInternal.functorMap.map(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.CustomParameterChoice)(part.customParameters)));
    return Data$dEither.bindEither.bind(Data$dMap$dInternal.foldableWithIndexMap.foldrWithIndex(i => x => {
      const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(i)(Data$dRecord.unsafeGet("customParameters")(catalogue));
      const $2 = (() => {
        if ($1.tag === "Just") {
          const $2 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(x)(Data$dRecord.unsafeGet("choices")($1._1)._1);
          if ($2.tag === "Just") {
            const $3 = $2._1;
            const $4 = $1._1;
            const $5 = Data$dEither.bindEither.bind((() => {
              const $5 = Data$dRecord.unsafeGet("availability")($3).tag === "Available";
              const $6 = parameterChoiceUnavailable($4, $3);
              if (!$5) { return $6; }
              if ($5) { return Data$dEither.$Either("Right", undefined); }
              $runtime.fail();
            })())(() => {
              const $5 = Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("availableWhen")($3))(parameterValues);
              const $6 = parameterChoiceUnavailable($4, $3);
              if (!$5) { return $6; }
              if ($5) { return Data$dEither.$Either("Right", undefined); }
              $runtime.fail();
            });
            return Data$dEither.applyEither.apply((() => {
              if ($5.tag === "Left") { return Data$dEither.$Either("Left", $5._1); }
              if ($5.tag === "Right") { return Data$dEither.$Either("Right", x$1 => x$1); }
              $runtime.fail();
            })())(Data$dEither.$Either("Right", undefined));
          }
          if ($2.tag === "Nothing") { return Data$dEither.$Either("Right", undefined); }
          $runtime.fail();
        }
        if ($1.tag === "Nothing") { return Data$dEither.$Either("Right", undefined); }
        $runtime.fail();
      })();
      return b => Data$dEither.applyEither.apply((() => {
        if ($2.tag === "Left") { return Data$dEither.$Either("Left", $2._1); }
        if ($2.tag === "Right") { return Data$dEither.$Either("Right", x$1 => x$1); }
        $runtime.fail();
      })())(b);
    })(Data$dEither.$Either("Right", undefined))(part.customParameters))(() => Data$dEither.bindEither.bind(Data$dMap$dInternal.foldableWithIndexMap.foldrWithIndex(i => x => {
      const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(i)(Data$dRecord.unsafeGet("modifiers")(catalogue));
      const $2 = (() => {
        if ($1.tag === "Nothing") { return Data$dEither.$Either("Right", undefined); }
        if ($1.tag === "Just") {
          const $2 = $1._1;
          const items = Restaumatic$dMenu$dV2$dMenuCatalogue.modifierItems($2);
          const $3 = Data$dFoldable.foldrArray(x$1 => {
            const $3 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(x$1)(items._1);
            const $4 = (() => {
              if ($3.tag === "Nothing") { return Data$dEither.$Either("Right", undefined); }
              if ($3.tag === "Just") {
                const $4 = $3._1;
                const $5 = Data$dEither.bindEither.bind((() => {
                  const $5 = Data$dRecord.unsafeGet("availability")($4).tag === "Available";
                  const $6 = modifierItemUnavailable($2, $4);
                  if (!$5) { return $6; }
                  if ($5) { return Data$dEither.$Either("Right", undefined); }
                  $runtime.fail();
                })())(() => {
                  const $5 = Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("availableWhen")($4))(parameterValues);
                  const $6 = modifierItemUnavailable($2, $4);
                  if (!$5) { return $6; }
                  if ($5) { return Data$dEither.$Either("Right", undefined); }
                  $runtime.fail();
                });
                return Data$dEither.applyEither.apply((() => {
                  if ($5.tag === "Left") { return Data$dEither.$Either("Left", $5._1); }
                  if ($5.tag === "Right") { return Data$dEither.$Either("Right", x$2 => x$2); }
                  $runtime.fail();
                })())(Data$dEither.$Either("Right", undefined));
              }
              $runtime.fail();
            })();
            return b => Data$dEither.applyEither.apply((() => {
              if ($4.tag === "Left") { return Data$dEither.$Either("Left", $4._1); }
              if ($4.tag === "Right") { return Data$dEither.$Either("Right", x$2 => x$2); }
              $runtime.fail();
            })())(b);
          })(Data$dEither.$Either("Right", undefined))(Data$dMultiSet.distinctElems(x));
          return Data$dEither.applyEither.apply((() => {
            if ($3.tag === "Left") { return Data$dEither.$Either("Left", $3._1); }
            if ($3.tag === "Right") { return Data$dEither.$Either("Right", x$1 => x$1); }
            $runtime.fail();
          })())(Data$dEither.$Either("Right", undefined));
        }
        $runtime.fail();
      })();
      return b => Data$dEither.applyEither.apply((() => {
        if ($2.tag === "Left") { return Data$dEither.$Either("Left", $2._1); }
        if ($2.tag === "Right") { return Data$dEither.$Either("Right", x$1 => x$1); }
        $runtime.fail();
      })())(b);
    })(Data$dEither.$Either("Right", undefined))(part.modifiers))(() => Data$dEither.$Either("Right", parameterValues)));
  };
  return Data$dEither.bindEither.bind(processPartLike(
    Data$dMap$dExtra.mapKeys(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterId.InternalParameter)(Data$dMap$dInternal.functorMap.map(Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.InternalParameterChoice)(Data$dFoldable.foldableArray.foldMap({
      mempty: Data$dMap$dInternal.Leaf,
      Semigroup0: () => ({append: Data$dMap$dInternal.union(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId)})
    })(x => x)([
      v.params,
      Data$dMap$dInternal.$$$Map(
        "Two",
        Data$dMap$dInternal.Leaf,
        Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.IsDivided,
        Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("IsDividedChoice", Data$dRecord.unsafeGet("parts")(productKey).length > 1),
        Data$dMap$dInternal.Leaf
      )
    ]))),
    productKey
  ))(toplevelParameterValues => {
    const $1 = Data$dArray$dNonEmpty$dInternal.foldable1NonEmptyArray.foldMap1({
      append: v$1 => v1 => Data$dEither.applyEither.apply((() => {
        if (v$1.tag === "Left") { return Data$dEither.$Either("Left", v$1._1); }
        if (v$1.tag === "Right") { return Data$dEither.$Either("Right", x => x); }
        $runtime.fail();
      })())(v1)
    })(x => {
      const $1 = processPartLike(toplevelParameterValues, x);
      if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
      if ($1.tag === "Right") { return Data$dEither.$Either("Right", undefined); }
      $runtime.fail();
    })(Data$dRecord.unsafeGet("parts")(productKey));
    if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
    if ($1.tag === "Right") { return Data$dEither.$Either("Right", undefined); }
    $runtime.fail();
  });
};
export {validateAvailability};
